import disqavaApi from "@/api/wordpressPage";

export const getCategoriesWP = async () =>
  await disqavaApi.get("/jb-job-category?per_page=100");
